/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Calm_Otter_SwimInputs */

const en_deep_calm_otter_swim = /** @type {(inputs: Deep_Calm_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const de_deep_calm_otter_swim = /** @type {(inputs: Deep_Calm_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {Deep_Calm_Otter_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_calm_otter_swim = /** @type {((inputs?: Deep_Calm_Otter_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Calm_Otter_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_calm_otter_swim(inputs)
	return de_deep_calm_otter_swim(inputs)
});